import React, { FC, useCallback } from 'react';
import { TextTooltip } from 'components/Tooltip';
import { Button } from 'reakit';
import { cx, LinariaClassName } from '@linaria/core';
import { flex } from 'styles/utils';
import { IconProps } from 'components/Icons/IconProps';
import { copyIconStyles } from './CopyButton.styles';
import { IconCopy } from '../Icons';
import { copyToClipboard } from '../../utils/copyToClipboard';

export interface CopyIconButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  tooltipText?: string;
  text: string;
  size?: number;
  toastMessage?: string;
  onFinish?: () => void;
  copyIcon?: FC<IconProps>;
  copyIconClassName?: LinariaClassName | string;
  iconProps?: IconProps;
}

export const CopyButton: FC<CopyIconButtonProps> = ({
  text,
  toastMessage,
  tooltipText,
  copyIcon,
  size,
  onFinish,
  className,
  copyIconClassName,
  iconProps,
}) => {
  const Icon = copyIcon || IconCopy;

  const onCopyClick = useCallback(
    ((evt) => {
      evt.stopPropagation();
      copyToClipboard(text, toastMessage)();
      if (onFinish !== undefined) {
        onFinish();
      }
    }) as React.MouseEventHandler<HTMLElement>,
    [text, toastMessage],
  );

  return (
    <TextTooltip text={tooltipText || 'Copy'}>
      <Button as="div" className={cx(className, flex.init, flex.alignItems.center)} onClick={onCopyClick}>
        <Icon
          data-testid="copy-to-clipboard-id"
          className={cx(copyIconStyles, copyIconClassName)}
          size={size || 20}
          color="currentColor"
          {...iconProps}
        />
      </Button>
    </TextTooltip>
  );
};
